<template>
    <div class="page wallet-page py-lg-6">
        <v-container :class="{'white px-0': phoneOnly}">            
            <transition name="fade" appear>
                <div v-if="wallet">
                    <v-alert v-if="errorQuery" text type="info" color="error">
                        حدثت مشكلة أثناء الدفع، حاول مرة أخرى. ({{errorQuery}})
                    </v-alert>
                    <v-row :class="{'mx-0': phoneOnly}">
                        <v-col cols="12" lg="4" :class="{'px-0': phoneOnly}">
                            <div :style="pcOnly ? 'position: sticky; top: 85px;' : ''">
                                <v-card flat class="wallet-widget pa-lg-2 lg:bordered">
                                    <template v-if="!appData.enable_wallet_transfers && !capRunning">
                                        <v-card-title class="title strong-text--text pt-lg-2">
                                            <v-icon color="strong-text" class="me-2">mdi-wallet-outline</v-icon>
                                            المحفظة الإلكترونية
                                        </v-card-title>
                                        <v-divider class="mx-4" style="opacity: 0.6"></v-divider>
                                    </template>

                                    <v-card-text class="text--text">
                                        <div class="balance-wrapper" :class="{'text-center': phoneOnly, 'text-right': pcOnly}">
                                            <div class="medium-text muted--text mb-3">الرصيد الحالي</div>
                                            <div class="balance mb-6">
                                                <!-- <span class="currency muted--text me-1" style="font-size: 1.25rem">USD</span> -->
                                                <span class="strong-text--text">{{moneyFormat(wallet.balance, true)}}</span>
                                            </div>
                                            <v-btn block outlined :depressed="pcOnly" color="primary" @click="rechargeDialog = true" :class="{'primary--text': phoneOnly}">
                                                <v-icon size="21" left>mdi-wallet-plus-outline</v-icon>
                                                شحن المحفظة
                                            </v-btn>
                                            <div v-if="!appData.enable_wallet_transfers" class="muted--text details-text mt-3 text-center">
                                                يمكنك شحن رصيد محفظتك بوسائل الدفع التي ندعمها لتتمكن من استخدام محفظتك في الشراء داخل المنصة
                                            </div>
                                        </div>

                                        <v-divider v-if="appData.enable_wallet_transfers" class="my-6"></v-divider>
                                        <div v-if="appData.enable_wallet_transfers" class="transfer-wrapper">
                                            <div class="mb-5">
                                                <div class="d-flex justify-space-between">

                                                    <div>
                                                        <qrcode-vue :value="wallet.address" :size="90" level="H" />
                                                    </div>
                                                    <div class="flex-grow-1 ps-7">
                                                        <div class="text-right mb-2">
                                                            <div class="medium-text mb-1">عنوان المحفظة</div>
                                                            <div class="strong-text--text font-weight-bold" style="font-size: 1.45rem; letter-spacing: 1.5px!important;">{{wallet.address}}</div>
                                                        </div>
                                                        <div class="details-text muted--text mt-3 text-right">
                                                            يمكنك استلام رصيد من محفظة أخرى عن طريق عنوان المحفظة الخاصة بك
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <v-btn block dark depressed color="derasacolor" @click="transferDialog = true">
                                                <v-icon left>mdi-cash-fast</v-icon>
                                                تحويل الرصيد
                                            </v-btn>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </div>
                            <!-- <div class="mt-4 text-center">
                                <supported-payment-methods :small="pcOnly" :height="phoneOnly ? 30 : 25"/>
                            </div> -->
                        </v-col>
                        <v-col cols="12" lg="8" :class="{'px-0': phoneOnly}">
                            <v-divider v-if="phoneOnly" class="my-2 mx-4"></v-divider>

                            <v-card flat :class="{'bordered pa-1': pcOnly}">
                                <v-card-title class="strong-text--text mb-2">
                                    <v-icon size="26" color="strong-text">mdi-order-bool-descending-variant</v-icon>
                                    <span class="ms-2">سجل العمليات</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-alert v-if="meta.pending_mobile_payments_count" type="info" dense color="blue-grey" icon="mdi-progress-clock" outlined text dismissible close-icon="mdi-close" class="mb-4">
                                        <div class="strong-text--text details-text">لديك <b>{{meta.pending_mobile_payments_count}}</b> عملية شحن قيد المراجعة، سيتم تأكيدها بأسرع وقت وإضافة الرصيد لحسابك.</div>
                                    </v-alert>
                                    <v-alert v-if="transferSuccess" type="success" dense color="success" icon="mdi-cash-fast" outlined text dismissible close-icon="mdi-close" class="mb-4">
                                        <span class="details-text success--text text--darken-3">{{transferSuccess}}</span>
                                    </v-alert>
                                    <div v-if="transactions && transactions.length">
                                        <v-simple-table class="e-data-table">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-right font-weight-medium">
                                                            # رقم العملية
                                                        </th>
                                                        <th class="text-right font-weight-medium">
                                                            تفاصيل العملية
                                                        </th>
                                                        <th class="text-center font-weight-medium">
                                                            المبلغ
                                                        </th>
                                                        <th class="text-left font-weight-medium">
                                                            وقت العملية
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(transaction) in transactions" :key="transaction.serial" style="white-space: nowrap!important;">
                                                        <td>
                                                            <div class="d-flex">
                                                                <!-- <v-icon size="18" color="muted" right style="margin-right -15px">mdi-check-circle-outline</v-icon> -->
                                                                <div>{{transaction.serial}}</div>
                                                            </div>
                                                        </td>
                                                        <td class="strong-text--text text-right">
                                                            <div v-if="transaction.type === 'recharge'">
                                                                <v-icon color="success darken-1" size="20" class="me-2">mdi-wallet-plus-outline</v-icon>
                                                                عملية شحن رصيد المحفظة
                                                            </div>
                                                            <div v-else-if="transaction.type === 'lecture_purchase'" class="details-text">
                                                                <v-icon color="secondary" size="20" class="me-2">mdi-clipboard-play-outline</v-icon>
                                                                عملية شراء محاضرة: <span class="details-text muted--text">{{stringLimit(transaction.lecture_resource.name, 25)}}</span>
                                                            </div>
                                                            <div v-else-if="transaction.type === 'course_purchase'" class="details-text">
                                                                <v-icon color="orange darken-3" size="20" class="me-2">mdi-play-box-multiple-outline</v-icon>
                                                                عملية شراء دورة: <span class="details-text link--text">{{stringLimit(transaction.course_resource.name, 25)}}</span>
                                                            </div>
                                                            <div v-else-if="transaction.type === 'package_purchase'" class="details-text">
                                                                <v-icon color="teal darken-2" size="20" class="me-2">mdi-package-variant-closed</v-icon>
                                                                {{transaction.package_resource && transaction.package_resource.action === 'renew' ? 'عملية تجديد اشتراك باقة:' : 'عملية اشتراك في باقة:'}}
                                                                <span class="details-text link--text">{{stringLimit(transaction.package_resource.name, 25)}}</span>
                                                            </div>
                                                            <div v-else-if="transaction.type === 'balance_transfer'" class="details-text nowrap">
                                                                <v-icon color="derasacolor" size="23" class="me-2">mdi-cash-fast</v-icon>
                                                                <span>
                                                                    <span v-if="transaction.transfer_resource && transaction.transfer_resource.recipient_user_name">
                                                                        عملية تحويل رصيد إلى:
                                                                        <strong>{{transaction.transfer_resource.recipient_user_name}}</strong>
                                                                    </span>
                                                                    <span v-else-if="transaction.transfer_resource && transaction.transfer_resource.sender_user_name">
                                                                        عملية استلام رصيد من:
                                                                        <strong>{{transaction.transfer_resource.sender_user_name}}</strong>
                                                                    </span>
                                                                    <span v-else>عملية تحويل رصيد</span>
                                                                </span>
                                                            </div>
                                                            <div class="details-text d-flex" v-else-if="transaction.type === 'admin_balance_update'">
                                                                <v-icon color="secondary" size="20" class="me-2">mdi-help-circle</v-icon>
                                                                <div><span>الدعم: </span> <span class="strong-text--text">{{transaction.comment}}</span></div>
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 14px" class="text-center">
                                                            <span v-if="transaction.value >= 0" class="success--text text--darken-1"> {{moneyFormat(transaction.value)}}</span>
                                                            <span v-if="transaction.value < 0" class="error--text text--darken-1">- {{moneyFormat(-1 * transaction.value)}}</span>

                                                            <v-tooltip color="tooltip" transition="fade-transition" bottom>
                                                                <template v-slot:activator="{on, attrs}">
                                                                    <v-chip label small class="px-1 ms-2 bordered" style="height: 18px" v-bind="attrs" v-on="on" color="transparent">
                                                                        <span v-if="transaction.balance_after || transaction.balance_after === 0" class="x-small-text muted--text"><v-icon color="muted" size="13">mdi-wallet-outline</v-icon> ${{moneyFormat(transaction.balance_after)}}</span>
                                                                    </v-chip>
                                                                </template>
                                                                <span>رصيد المحفظة بعد العملية</span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td class="text-left ltr-dir">
                                                            {{dateTimeFormat(transaction.timestamp, true)}}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                        <v-btn v-if="transactionsNext" block text color="primary" class="mt-3 surface2" v-ripple="phoneOnly" @click="loadMoreTransactions">
                                            تحميل المزيد من العمليات...
                                        </v-btn>
                                    </div>
                                    <div v-else>
                                        <v-alert type="info" dense color="blue-grey" text class="mb-0">
                                            <div class="details-text">لا يوجد أي عمليات تمت على المحفظة الخاصة بك.</div>
                                        </v-alert>
                                    </div>
                                </v-card-text>

                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </transition>
        </v-container>

        <!-- Dialogs -->

        <div v-if="wallet" class="dialogs">
            <v-dialog v-model="rechargeDialog" max-width="500" overlay-color="#000000" scrollable overlay-opacity="0.8" :fullscreen="phoneOnly" :fluid="phoneOnly" persistent>
                <recharge :wallet="wallet" @close="rechargeDialog = false" @reload-data="reloadWalletData" />
            </v-dialog>


            <v-dialog v-model="transferDialog" max-width="425" overlay-color="#000000" scrollable overlay-opacity="0.8" :fullscreen="phoneOnly" :fluid="phoneOnly">
                <v-card class="billing-dialog p-relative">
                    <v-progress-linear v-if="transferring" active value="0" indeterminate absolute top color="derasacolor" :height="pcOnly ? 2 : 2" ></v-progress-linear>

                    <v-card-title class="mb-1">
                        <v-icon size="26" color="derasacolor" class="me-2">mdi-cash-fast</v-icon>
                        تحويل الرصيد
                    </v-card-title>
                    <v-card-subtitle>تحويل الرصيد من محفظتك إلى محفظة أخرى</v-card-subtitle>
                    <v-card-text>
                        <div class="mb-5">
                            <v-alert v-if="appData.transfer_fees" text dense type="info" color="blue-grey" icon="mdi-cash-minus" class="medium-text">سيتم خصم رسوم بقيمة {{moneyFormat(appData.transfer_fees, true)}} من المبلغ</v-alert>
                            <!-- <v-alert v-else text dense type="info" color="derasacolor" icon="mdi-currency-usd-off" class="medium-text">لا يوجد رسوم على عملية التحويل</v-alert> -->
                        </div>

                        <v-form @submit.prevent>
                            <v-text-field v-model="transferAddress" color="derasacolor" autofocus :disabled="transferring" min-height="30" placeholder="أدخل عنوان محفظة المستلم" label="عنوان المحفظة" outlined prepend-inner-icon="mdi-qrcode" hide-details class="mb-5"></v-text-field>
                            <v-text-field ref="transferAmountInput" prepend-inner-icon="mdi-cash-fast" color="derasacolor" :disabled="transferring" :max="wallet.balance" min="1" type="number" label="المبلغ" placeholder="أدخل المبلغ الذي تريد تحويله" hide-details flat v-model="transferAmount" outlined class="mb-2" /> <!-- step="any" -->
                        </v-form>

                    </v-card-text>
                    <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                        <v-btn text color="muted" :disabled="transferring" @click="transferDialog = false">إخفاء</v-btn>
                        <v-btn text color="derasacolor" class="font-weight-bold ms-2" :loading="transferring" :disabled="transferring || !transferAmount || transferAmount < 0.5 || !transferAddress" @click="transferBalance">تأكيد</v-btn>

                        <v-btn icon absolute top left :disabled="transferring" @click="transferDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import QrcodeVue from 'qrcode.vue'

import Recharge from './recharge'


export default {
    name: "Wallet",
    components: {
        QrcodeVue,
        Recharge,
    },
    data(){
        return {
            loading: false,
        
            wallet: null,
            transactions: null,
            transactionsNext: null,
            meta: null,
            
            rechargeDialog: false,

            transferDialog: false,
            transferring: false,
            transferAddress: '',
            transferAmount: '',
            transferSuccess: '',
        }
    },
    computed: {
        ...GlobalComputed,
        errorQuery(){
            return this.$route.query && this.$route.query.error ? this.$route.query.error : null;
        }
    },
    watch: {
        
    },
    methods: {
        reloadWalletData(){
            this.loadWalletData();
            this.scrollToTop(true);
        },
        loadWalletData(moreTransactions=false){
            if (!this.loading){
                this.loading = true;
                if (!moreTransactions) this.setLinearLoading(true);
                let payload = {};
                if (moreTransactions){
                    payload.url = this.transactionsNext;
                }

                this.$store.dispatch('loadWalletData', payload).then(response=>{
                    this.setLinearLoading(false);
                    if (!moreTransactions) this.setLinearLoading(false);
                    this.loading = false;
                    this.wallet = response.data.wallet;
                    this.meta = response.data.meta;
                    if (moreTransactions){
                        const transactions = response.data.transactions ? response.data.transactions.data : [];
                        this.transactions.push(...transactions);

                    }else{
                        this.transactions = response.data.transactions ? response.data.transactions.data : null;
                    }
                    this.transactionsNext = response.data.transactions && response.data.transactions.links ? response.data.transactions.links.next : null;

                }).catch(()=>{
                    this.setLinearLoading(false);
                    this.showMsg('حدثت مشكلة أثناء تحميل بيانات المحفظة');
                    this.loading = false;
                    if (!moreTransactions) this.setLinearLoading(false);
                });
            }
        },
        loadMoreTransactions(){
            this.loadWalletData(true);
        },
        transferBalance(){
            if (!this.transferring){
                this.transferSuccess = null;
                this.transferring = true;
                this.$store.dispatch('transferBalance', {amount: this.transferAmount, wallet_address: this.transferAddress}).then(response=>{
                    const amount = response.data.amount;
                    const balance = response.data.balance;
                    const transaction = response.data.transaction;
                    const transactionSerial = response.data.serial;

                    this.transactions.unshift(transaction);
                    Object.assign(this.wallet, {balance});

                    this.transferring = false;
                    this.transferDialog = false;
                    this.showMsg('تم تحويل الرصيد بنجاح', 'success', false, false, 2000);
                    this.transferSuccess = `تمت عملية تحويل ${this.moneyFormat(amount, true)} بنجاح... رقم العملية #${transactionSerial}`;

                    window.setTimeout(()=>{
                        this.transferAmount = '';
                        this.transferAddress = '';
                    }, 500);

                }).catch(e=>{
                    this.transferring = false;

                    let msg = e && e.response && e.response.data ? e && e.response.data : null;
                    if (msg){
                        if (msg === 'NO_ENOUGH_BALANCE'){
                            this.showMsg('رصيدك غير كافي لإتمام العملية', 'error');
                        }else if (msg === 'WALLET_NOT_FOUND'){
                            this.showMsg('لم يتم العثور على محفظة المستلم', 'error');
                        }else if (msg === 'CANNOT_TRANSFER_TO_YOURSELF'){
                            this.showMsg('لا يمكنك تحويل رصيد إلى محفظتك!', 'error');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، لم يتم تحويل الرصيد', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، لم يتم تحويل الرصيد', 'error');
                    }
                })
            }
        },
        ...GlobalMethods,
    },
    mounted(){
        if (this.appData.enable_wallet_system){
            this.loadWalletData();
            this.scrollToTop();
            if (this.$route.query && this.$route.query.recharge){
                this.rechargeDialog = true;
            }
        }else{
            this.$router.push('/not-found');
        }
    }
};
</script>
<style lang="scss" scoped>
.wallet-widget{
    .balance{
        font-size: 2rem;
        font-weight: 500;
        font-family: 'Open Sans';
    }
}
</style>